'use client';

import { createContext, useContext, useState } from 'react';

import type { HeaderVariant } from '@/shared/components/layout/Header';

type HeaderVariantContextValue = {
  variant: HeaderVariant | null;
  setVariant: (variant: HeaderVariant | null) => void;
  /** null: prop 값 그대로 사용 / true·false: prop 값 override */
  lnbOverlay: boolean | null;
  setLNBOverlay: (value: boolean | null) => void;
  /** null: prop 값 그대로 사용 / true·false: prop 값 override */
  defaultLNBOpen: boolean | null;
  setDefaultLNBOpen: (value: boolean | null) => void;
  /** null: prop 값 그대로 사용 / true·false: Header overlay(fixed) 여부 override */
  headerOverlay: boolean | null;
  setHeaderOverlay: (value: boolean | null) => void;
  /** null: lnbOptions.hideMobile 그대로 / true·false: override */
  lnbHideMobile: boolean | null;
  setLNBHideMobile: (value: boolean | null) => void;
};

const HeaderVariantContext = createContext<HeaderVariantContextValue>({
  variant: null,
  setVariant: () => {},
  lnbOverlay: null,
  setLNBOverlay: () => {},
  defaultLNBOpen: null,
  setDefaultLNBOpen: () => {},
  headerOverlay: null,
  setHeaderOverlay: () => {},
  lnbHideMobile: null,
  setLNBHideMobile: () => {},
});

export function HeaderVariantProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [variant, setVariant] = useState<HeaderVariant | null>(null);
  const [lnbOverlay, setLNBOverlay] = useState<boolean | null>(null);
  const [defaultLNBOpen, setDefaultLNBOpen] = useState<boolean | null>(null);
  const [headerOverlay, setHeaderOverlay] = useState<boolean | null>(null);
  const [lnbHideMobile, setLNBHideMobile] = useState<boolean | null>(null);
  return (
    <HeaderVariantContext.Provider
      value={{
        variant,
        setVariant,
        lnbOverlay,
        setLNBOverlay,
        defaultLNBOpen,
        setDefaultLNBOpen,
        headerOverlay,
        setHeaderOverlay,
        lnbHideMobile,
        setLNBHideMobile,
      }}
    >
      {children}
    </HeaderVariantContext.Provider>
  );
}

export function useHeaderVariant() {
  return useContext(HeaderVariantContext);
}
